import React, { Fragment, useEffect } from 'react';
import { LOGOUT_URL } from 'src/constants/constants.js';
import { LOGIN_STATUS } from 'src/ui/features/Login/state/loginTypes';
import LoginError from './forms/LoginErrorPres';
import SelectRoleContainer from '../containers/SelectRoleContainer';

export default function LoginSso({ error, loginSso, logoutSession, loginStatus, numberAttempts, isRoleSelect }) {
  useEffect(() => {
    if (window.location.href.includes(LOGOUT_URL)) {
      sessionStorage.clear();
      logoutSession();

      // if (window.location.href.includes(LOGOUT_URL_BIZCOMP_REDIRECT)) {
      //   window.location.href = BIZCOMP_LOGOUT_URL;
      // }

      return;
    } else {
      if ((loginStatus === LOGIN_STATUS.FAILURE || loginStatus === undefined) && numberAttempts <= 0) {
        loginSso();
      }
    }
  });

  return isRoleSelect ? (
    <SelectRoleContainer />
  ) : (
    <Fragment>
      <div style={{ margin: '2em' }}>
        {error && error.message ? <LoginError isUserLocked={false} numberAttempts={0} error={error} maxAttempts={'third attempt'} /> : null}
      </div>
    </Fragment>
  );
}
